import _ from 'lodash'
import { Role, serverTime } from '@/core/api/util.api'
import moment from 'moment'
import { Vue } from '@/utils'

export default {
  DOCUMENT_VISIBILITY_STATE: (state, {visibilityState}) => {
    if(visibilityState === undefined && globalThis.document){
      visibilityState = document.visibilityState;
    }
    state.documentVisibilityState = visibilityState
  },
  ROOM_INIT: (state, roomData) => {
    // 임시 : 그룹 토의 S
    const randomColor = () => {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    }

    roomData.roomGroupList?.sort((a, b) => {
        if (a.roomGroupName && b.roomGroupName) {
          return (
            a.roomGroupName.replace('그룹', '') -
            b.roomGroupName.replace('그룹', '')
          )
        }
      })
      .forEach(rg => {
        Object.assign(rg, {
          userList: [],
          color: randomColor()
        })
      })

    roomData.roomUserList.filter(roomUser => {
      const roomGroupId = roomUser.roomGroupId

      const idx = roomData.roomGroupList?.map(group => group.roomGroupId)
        .indexOf(roomGroupId)

      if (idx > -1) {
        roomData.roomGroupList[idx].userList.push(roomUser)
      }
    })
    // 임시 : 그룹 토의 E

    // 연습 모드
    Object.assign(roomData.room, {
      isTestMode: false,
      freeMinutes: 10, // 입장 가능시간 n분 전까지 연습모드 활성
    });

    state.me = roomData.me
    state.room = roomData.room
    // state.roomCall = Object.assign(state.roomCall, roomData.roomCall)
    state.roomDoc = roomData.roomDoc
    state.roomMedia = roomData.roomMedia
    state.roomShareNote = roomData.roomShareNote
    state.roomUserList = roomData.roomUserList
    state.roomUserObj = roomData.roomUserObj
    state.roomGroupList = roomData.roomGroupList
    state.roomGoalList = roomData.roomGoalList
    state.roomScheduleList = roomData.roomScheduleList
    state.roomInfo = roomData.roomInfo

    state.roomDataInitComplete = true;
    console.log('# roomDataInitComplete');
  },
  ROOM_INFO_INIT: (state, roomData) => {
    state.roomInfo = roomData.roomInfo
    console.log('# roomInfoDataInit');
  },
  ROOM_LMS_INIT: (state, data) => {
    /**
     * CHECK TEST MODE
     */
    (async () => {
      const { startDate, enterAvailableMinute } = data;
      const currentTime = new Date(await serverTime()).getTime();
      const enterAvailableTime = new Date(startDate).getTime() - (enterAvailableMinute * 60000);
      const beforeLectureStartTime = currentTime + state.room.freeMinutes * 60 * 1000 < enterAvailableTime;
      if (beforeLectureStartTime) {
        data = Object.assign(data, {
          enterAvailableTime,
          beforeLectureStartTime
        })
        state.room.isTestMode = true;
      }
    })();

    state.roomLms = data;
    console.log('# roomLmsDataInitComplete');
  },
  SET_DEVICE_SETTINGS: (state, deviceSettings) => {
    state.deviceSettings = deviceSettings;
  },
  ROOM_CONNECTED: (state) => {
    state.connectionState = 'connected';
  },
  ROOM_DISCONNECTED: (state, data) => {
    let connState = data?.retry ? 'retry' : 'disconnected';
    state.connectionState = connState;
  },
  ROOM_RECONNECTED: (state, data) => {
    state.connectionState = 'connected';
  },
  ROOM_LEAVED: (state, data) => {
    if(!state.leaved){
      state.leaved = true;
      state.leaveReason = data?.reason;
    }
  },

  /**
   * 노이즈 캔슬 관련
   */
  NOISE_CANCEL_DISABLE: function(state, data){
    state.noiseCancelAvailable = false;
  },

  CHANGE_ROOM_MODE: (state, { roomMode }) => {
    if (state.room.roomMode === roomMode) {
      return;
    }

    const existPrevRoomMode = state.room.prevRoomMode;
    if (!existPrevRoomMode) {
      Vue.set(state.room, 'prevRoomMode', state.room.roomMode);
    } else {
      state.room.prevRoomMode = state.room.roomMode;
    }
    state.room.roomMode = roomMode
  },
  REMOVE_ROOM_USER: (state, {userId, currJoinCnt}) => {
    if(!userId) return;

    if(!isNaN(currJoinCnt)){
      state.room.currJoinCnt = currJoinCnt;
    }

    delete state.roomUserObj[userId];

    const index = state.roomUserList.findIndex(user => user.userId === userId);
    if(index < 0) return;
    state.roomUserList.splice(index, 1);
  },
  CHANGE_USER_STATUS: (state, {userId, userStatus}) => {
    const ru = state.roomUserObj[userId];
    if(!ru) return;
    ru.userStatus = userStatus;
  },
  SET_ROOM_USER: (state, {roomUser, currJoinCnt}) => {
    if(!isNaN(currJoinCnt)){
      state.room.currJoinCnt = currJoinCnt;
    }

    const existRoomUser = state.roomUserObj[roomUser.userId]

    if (existRoomUser) {
      _.merge(existRoomUser, roomUser)
    } else {
      state.roomUserList.push(roomUser)
      Vue.set(state.roomUserObj, roomUser.userId, roomUser);
    }
  },
  CHANGE_ROOM_USER_NICKNAME: (state, {userId, nickname}) => {
    const existRoomUser = state.roomUserObj[userId]

    if (existRoomUser) {
      existRoomUser.nickname = nickname;
    } else {
      throw 'room user not exist: userId[${userId}]';
    }
  },
  SET_ROOM_USER_LIST: function(state, roomUserList){
    let me = this.getters['user/me']
    roomUserList && roomUserList.forEach(user => {
      this.getters['user/getRoomUser'](user.userId) && (this.getters['user/getRoomUser'](user.userId).roomGroupId = user.roomGroupId)
      let u = this.getters['roomGroup/getRoomGroup'](user.roomGroupId).userList.find(u => u.userId == user.userId)
      if(u) {
        _.merge(u, user)
      } else {
        this.getters['roomGroup/getRoomGroup'](user.roomGroupId).userList.push(user)
      }
      if(me.userId === user.userId) {
        me.roomGroupId = user.roomGroupId
      }
    })
  },
  CHANGE_ROOM_USER_DEVICE_STATUS: (state, data) => {
    const existRoomUser = state.roomUserObj[data.userId]

    if (existRoomUser) {
      existRoomUser[data.deviceType + 'Status'] = data.deviceStatus

      if (state.me.userId == data.userId) {
        state.me = existRoomUser
      }
    }
  },
  CHANGE_ROOM_USER_DEVICE_STATUS_ALL: (state, device) => {
    state.roomUserList.forEach(roomUser => {
      if (roomUser.roomUserRole.roleId !== Role.SPEAKER) {
        roomUser[device.deviceType + 'Status'] = device.deviceStatus
      }

      if (state.me.userId === roomUser.userId) {
        state.me = roomUser
      }
    })
  },
  CHANGE_ROOM_USER_ROLE: (state, role) => {
    const existRoomUser = state.roomUserObj[role.userId]

    if (existRoomUser) {
      existRoomUser.roomUserRole[role.roleType] = role.roleStatus

      if (state.me.userId == role.userId) {
        state.me.roomUserRole = existRoomUser.roomUserRole
      }
    }
  },
  CHANGE_ROOM_USER_ROLE_ALL: (state, role) => {
    state.roomUserList.forEach(roomUser => {
      if (roomUser.roomUserRole.roleId !== Role.SPEAKER) {
        roomUser.roomUserRole[role.roleType] = role.roleStatus
      }

      if (state.me.userId === roomUser.userId) {
        state.me = roomUser
      }
    })
  },

  /////////////////////////////////////

  SORT_ROOM_USER_LIST: function(state, type) {
    switch (type) {
      case 'entryOrder':
        state.roomUserList
          .sort((a, b) => {
            return moment(a.enterDate).format('YYYYMMDDHHmmss') - moment(b.enterDate).format('YYYYMMDDHHmmss')
          })
        break
      case 'nameOrder':
        state.roomUserList
          .sort((a, b) => {
            const sortName = a.nickname && b.nickname ? 'nickname' : 'username';

            if (a[sortName] > b[sortName]) {
              return 1;
            } else if (a[sortName] < b[sortName]) {
              return -1;
            } else {
              return 0;
            }
          });
        break
      case 'lowOrder':
        state.roomUserList
          .sort((a, b) => {
            if (!a.speakTimePercent == undefined || !b.speakTimePercent == undefined) return
            return a.speakTimePercent - b.speakTimePercent
          })
        break
      case 'highOrder':
        state.roomUserList
          .sort((a, b) => {
            if (!a.speakTimePercent == undefined || !b.speakTimePercent == undefined) return
            return b.speakTimePercent - a.speakTimePercent
          })
        break
      }
  },

  CLEAR_SCREEN_SHARE_STATUS: (state, {roomMode}) => {
    if(state.room.prevRoomMode === 'screenShare'
        && state.room.prevRoomMode !== roomMode){
      state.roomUserList.forEach(user => {
        state.roomUserObj[user.userId].screenStatus = false;
      });
    }
  },

  SET_ROOM_USER_SCREEN_SHARE: (state, screen) => {
    let { userIds, userId, screenShare } = screen;

    if (!userIds || !userIds.length) {
      if(userId){
        userIds = [userId];
      }else{
        console.warn('Not Found ScreenShare RoomUser => SET_ROOM_USER_SCREEN_SHARE');
        return;
      }
    }

    state.roomUserList.forEach(user => {
      state.roomUserObj[user.userId].screenStatus = false;
    });

    userIds.forEach(userId => {
      const existRoomUser = state.roomUserObj[userId];

      if (!existRoomUser) {
        console.error('Not Found RoomUser => SET_ROOM_USER_SCREEN_SHARE', `userId = ${userId}`);
        return;
      }

      existRoomUser['screenStatus'] = screenShare;

      if (state.me.userId == userId) {
        state.me = existRoomUser;
      }
    });
  },

  /////////////////////////////////////

  CHANGE_ALL_USER_AUTH_STATUS: (state, type) => {
    switch (type) {
      case 'onAllCamera':
        state.roomUserList.map(roomUser => {
          if (!roomUser.roomUserRole.camera) return

          roomUser.cameraStatus = '0'
        })
        break
      case 'offAllCamera':
        state.roomUserList.map(roomUser => {
          if (!roomUser.roomUserRole.camera) return

          roomUser.cameraStatus = '1'
        })
        break
      case 'giveAllCamera':
        state.roomUserList.map(roomUser => {
          roomUser.roomUserRole.camera = true
        })
        break
      case 'takeawayAllCamera':
        state.roomUserList.map(roomUser => {
          roomUser.cameraStatus = '1'
          roomUser.roomUserRole.camera = false
        })
        break
      case 'onAllMic':
        state.roomUserList.map(roomUser => {
          if (!roomUser.roomUserRole.mic) return

          roomUser.micStatus = '0'
        })
        break
      case 'offAllMic':
        state.roomUserList.map(roomUser => {
          if (!roomUser.roomUserRole.mic) return

          roomUser.micStatus = '1'
        })
        break
      case 'giveAllMic':
        state.roomUserList.map(roomUser => {
          roomUser.roomUserRole.mic = true
        })
        break
      case 'takeawayAllMic':
        state.roomUserList.map(roomUser => {
          roomUser.micStatus = '1'
          roomUser.roomUserRole.mic = false
        })
        break
      case 'takeawayAllDraw':
        state.roomUserList.map(roomUser => {
          roomUser.roomUserRole.draw = false
        })
        break
    }
  },
  CHANGE_TAB_MODE: (state, mode) => {
    state.tabMode = mode;
  },

  ////////////////////////////////////////////////////////////////////////

  // 참여자 목록 정렬 선택
  SELECT_SORT: (state, e) => {
    const type = e.currentTarget.getAttribute('name')
    const Text = e.currentTarget.innerText

    state.room.rightSide.contentsParti.sortType = type
    state.room.rightSide.contentsParti.sortTx = Text
    state.room.rightSide.contentsParti.sortModal = false
  },

  CHANGE_ROOM_SCHEDULE_STATE: (state, data) => {
    state.roomScheduleList = _.cloneDeep(data)
  },
  CHANGE_ROOM_USER_ROLE_ID: (state, data) => {
    const {userId, roleId} = data;
    if(roleId === 'speaker'){
      const speakerUser = state.roomUserList.find(ru=>ru.roomUserRole.roleId === roleId)
      if(speakerUser)
        speakerUser.roomUserRole.roleId = 'emcee'
    }
    state.roomUserList.find(ru=>ru.userId===data.userId).roomUserRole.roleId = data.roleId
  },
  CHANGE_ROOM_USER_ROLE_ID_DEVICE: (state, data) => {
    console.log('==================================================================')
    console.log(data)
    state.roomUserList.find(ru=>ru.userId===data.userId).roomUserRole[data.device] = data.newStatus
  },

  /*
   * 토글 관련 코드
   */
  TOGGLE_MODAL_DEVICE_SETTING: (state, status) => {
    state.isModalDeviceSetting = status
  },
  TOGGLE_SHOW_PARTICIPATION_RATE: (state, show) => {
    if(show === undefined){
      show = !state.showParticipationRate;
    }
    state.showParticipationRate = !!show;
  },
  SHOW_SIDE_WRAP: (state, status = false) => {
    state.isShowSideWrap = status;
  },
  CHANGE_READY_TO_SCHEDULE: (state, status = true) => {
    state.readyToSchedule = status;
  },
  CHANGE_READY_TO_SCHEDULE_TIME: (state, time) => {
    state.readyToScheduleTime = time;
  },
  TOGGLE_FULL_SCREEN: (state) => {
    state.isFullScreen = !state.isFullScreen;
  },
  SET_FULL_SCREEN: (state, status) => {
    state.isFullScreen = status;
  },

  /**
   * 연습 모드
   */
  START_TEST_MODE: (state, data) => {
    state.room.isTestMode = true
  },
  
  
  SET_DEVICES: (state, devices) => {
    state.devices = devices
  },
  CHANGE_ROOM_TITLE: (state, data) => {
    state.room.roomTitle = data.roomTitle
  },
  CHANGE_ROOM_DEFINE_PASSWD: (state, data) => {
    state.room.definePasswd = data.definePasswd
    state.room.passwd = data.passwd
  },
  CHANGE_ROOM_INFO: (state, data) => {
    state.room.roomTitle = data.roomTitle
    state.room.definePasswd = data.definePasswd
    state.room.passwd = data.passwd
    state.room.beginDate = data.beginDate
    state.room.endResvDate = data.endResvDate
  },
  CHANGE_LOW_POWER_MODE: (state, level) => {
    state.lowPowerMode = level;
  },
  CHANGE_ROOM_DEFAULT_DEVICE_STATUS: (state, data) => {
    state.room.defaultCameraStatus = data.defaultCameraStatus
    state.room.defaultMicStatus = data.defaultMicStatus
  },
  CHANGE_ROOM_END_RESV_DATE: (state, data) => {
    state.room.endResvDate = data.endResvDate
  },
  SET_ROOM_LEVEL: (state, data) => {
    state.room.roomLevel = data.roomLevel
  },
  SET_ROOM_PASSWORD: (state, data) => {
    state.room.definePasswd = data.useDefinePasswd
    state.room.passwd = data.passwd
  }
}
